import React from 'react';
import { Container, Row, Col, } from 'react-bootstrap';
import { FaPhoneVolume } from "react-icons/fa6";
import { MdLocationOn, MdOutlineEmail } from "react-icons/md";

import Imglinkidin from '../../assets/Footer/Linkdin.webp'
import Imgyoutube from '../../assets/Footer/youtube.webp'


import { Link } from 'react-router-dom';
import './HfFooter.css'

import { useTranslation } from 'react-i18next';


const HfFooter = () => {
  const { t } = useTranslation();
  return (
    <footer className='hfFooter-wrapper' id='contact-us-section'>
      <Container className='hfFooter-container'>
        <Row className="justify-content-center " style={{ marginLeft: 'auto' }}>
          <Col sm={12} lg={3} >
            <div className='footer-column-div'>
              <b>{t('How to reach us')}</b>
              <ul>
                <li><a href="+44 028 90833813" className="footer-link"><FaPhoneVolume />(0044) 028 90833813 (NI)</a></li>
                <li><a href="+353 01 6251962" className="footer-link"><FaPhoneVolume />(00353) 01 6251962 (ROI)</a></li>
                <li><a href="ni.info@hansa-flex.com" className="footer-link"><MdOutlineEmail />ni.info@hansa-flex.com</a></li>
                <li><a href="https://www.google.com/maps/place/HANSA-FLEX+(NI)/@54.5442439,-6.0201206,17z/data=!3m1!4b1!4m6!3m5!1s0x4861a728a4066a45:0xc6c8deac667e23e2!8m2!3d54.5442439!4d-6.0201206!16s%2Fg%2F11g4j06f9c?entry=ttu&g_ep=EgoyMDI1MDcxNi4wIKXMDSoASAFQAw%3D%3D" target='_blank' className="footer-link"><MdLocationOn />HANSA-FLEX (NI), 74 Derriaghy Industrial Park BT17 9HU Dunmurry, Co. Antrim, Northern Ireland</a></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t("About HANSA-FLEX")}</b>
              <ul>
                <li><Link to="/who-we-are" className="footer-link">Who We Are</Link></li>
                {/* <li><Link to="/certificates" className="footer-link">Certificates</Link></li> */}
                <li><Link to="/hf-group-mission-statement" className="footer-link">Guidelines</Link></li>
                <li><Link to="/careers" className="footer-link">Careers</Link></li>
                {/* <li><Link to="/code-of-conduct" className="footer-link">Code of Conduct</Link></li> */}
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t("Services")}</b>
              <ul>
                <li><Link to="/mobile-rapid-hydraulic-service" className="footer-link">MHS</Link></li>
                <li><Link to="/industrial-hose-inspection" className="footer-link">Industrial Service</Link></li>
                <li><Link to="/x-code-manager" className="footer-link">X-CODE Hose Management System</Link></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t('Popular Categories')}</b>
              <ul>
                <li><a href="https://my.hansa-flex.ie/" target="_blank" rel="noopener noreferrer" className="footer-link">{t("My.HANSA-FLEX")}</a></li>
                <li><Link to="/hydraulic-hoses" className="footer-link">{t("Hydraulic Hoses")}</Link></li>
                {/* <li><Link to="/news-events" className="footer-link">{t("News & Events")}</Link></li>                */}
              </ul>
              <br />
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="d-flex justify-content-center align-items-center">
            <b>{t('Follow us')}</b>
          </Col>
        </Row>


        <Row className="custom-3row ">
          <Col><div className="circle-col"><a href="https://www.linkedin.com/in/martin-murray-3b086664/?originalSubdomain=uk" target="_blank" rel="noopener noreferrer"><div><img src={Imglinkidin} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.youtube.com/channel/UCxEVYG0w2OgkYzkLDiWIoOA" target="_blank" rel="noopener noreferrer"><div><img src={Imgyoutube} alt="" /></div></a></div></Col>
          
        </Row>

        <Row className="line-row">
          <Col className="line-col"></Col>
        </Row>

        <div className='HfFooter-link-div'>
          <a className="hf-footer-link" href="">{t("© Copyright, All rights reserved")}</a><span>  |  </span>
          <Link to="/hansa-flex-ireland-privacy-policy" className="footer-link">{t("Privacy Policy")}</Link>
          <span>  |  </span>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              document.cookie = "HFCookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              window.location.reload();
            }}
            className="footer-link"          >
            {t('Manage Cookie Preferences')}
          </a>
        </div>
      </Container>
    </footer >

  );
};

export default HfFooter;
